import { createRoot } from "react-dom/client";
import App from "./App";  // Remove .js extension
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);